import { createBrowserRouter, Navigate } from "react-router";
import { RootLayout } from "./features/root";
import { RouteError } from "./features/error";
import { productRoute, availabilityRoute } from "./features/product/product.routes";
import { purchaseRoute } from "./features/purchase/purchase.routes";
import { saleRoute } from "./features/sale/sale.routes";
import { customerRoute } from "./features/customer/customer.routes";
import { locationRoute } from "./features/location/location.routes";
import { taxRoute } from "./features/tax/tax.routes";
import { reportRoute } from "./features/report/report.routes";
import { reconciliationRoute } from "./features/reconciliation/reconciliation.routes";
import { orderRoute } from "./features/order/order.routes";
import { webhookLogRoute } from "./features/webhook-log/webhookLog.routes";
import { inventoryRoute } from "./features/inventory/inventory.routes";
import { jobRoute } from "./features/job/job.routes";
import { sandboxRoute } from "./features/sandbox/sandbox.routes";
import { dashboardRoute } from "./features/dashboard/dashboard.routes";
import { DASHBOARD_SEGMENT } from "./features/dashboard/dashboard.paths";

const domainRoutes = [
  { index: true, element: <Navigate to={DASHBOARD_SEGMENT} replace /> },
  dashboardRoute,
  productRoute,
  availabilityRoute,
  purchaseRoute,
  saleRoute,
  customerRoute,
  locationRoute,
  taxRoute,
  orderRoute,
  inventoryRoute,
  webhookLogRoute,
  jobRoute,
  reportRoute,
  reconciliationRoute,
];

/** The app's data-mode router: each feature's routes under the root layout. */
export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <RouteError />,
    children: [...domainRoutes, sandboxRoute],
  },
]);
